import React from 'react';
import dynamic from 'next/dynamic';
import { EndUserComponent } from '@aurora/shared-types/pages/enums';
import useTranslation from '../../useTranslation';

const ConfirmationDialog = dynamic(
  () => import('@aurora/shared-client/components/common/ConfirmationDialog/ConfirmationDialog'),
  { ssr: false }
);

interface Props {
  /**
   * URL to open in new tab on continue
   */
  url: string;
  /**
   * Whether to show the warning modal
   */
  show: boolean;
  /**
   * callback function that handles the onHide action of the modal.
   */
  onHide: () => void;
}

/**
 * Renders the ExternalLinkWarningModal, which warns users when clicking on external links
 *
 * @author Kunal Punjrath
 */
const ExternalLinkWarningModal: React.FC<React.PropsWithChildren<Props>> = ({
  url,
  show,
  onHide
}) => {
  const { formatMessage } = useTranslation(EndUserComponent.EXTERNAL_LINK_WARNING_MODAL);

  return (
    <ConfirmationDialog
      data-testid="ExternalLinkWarningModal"
      show={show}
      onHide={() => onHide()}
      onSubmit={() => {
        window.open(url, '_blank').focus();
        onHide();
      }}
      onCancel={() => onHide()}
      titleText={formatMessage('title')}
      bodyText={formatMessage('description')}
      submitButtonText={formatMessage('action.submit')}
      cancelButtonText={formatMessage('action.cancel')}
    />
  );
};
export default ExternalLinkWarningModal;
